


import { Component, Vue } from "vue-property-decorator";

import { CustomNotification, CustomValue } from "@Internal/Models";

import { $t, EventBus } from "App/IOC";
import { Option } from "Web/Contracts";
import SimpleSelect from "Web/Components/V2/Select/Simple.vue";

const TIMEZONE_KEY = "prospeneo-console-timezone";
const TIMEFORMAT_KEY = "prospeneo-console-timeformat";

interface TimeZoneOption {
    Value: string;
    Label: string;
}

/* A short, curated list of the zones Console staff work in — not the full IANA database. */
const TIMEZONES: TimeZoneOption[] = [
    { Value: "Europe/Paris", Label: "(GMT+01:00) Paris, Bruxelles, Madrid" },
    { Value: "Europe/London", Label: "(GMT+00:00) Londres, Lisbonne" },
    { Value: "Atlantic/Reykjavik", Label: "(GMT+00:00) Reykjavik" },
    { Value: "Europe/Athens", Label: "(GMT+02:00) Athènes, Bucarest" },
    { Value: "America/New_York", Label: "(GMT-05:00) New York, Toronto" },
    { Value: "America/Los_Angeles", Label: "(GMT-08:00) Los Angeles, Vancouver" },
    { Value: "Indian/Reunion", Label: "(GMT+04:00) La Réunion, Maurice" },
    { Value: "America/Guadeloupe", Label: "(GMT-04:00) Guadeloupe, Martinique" }
];

@Component( { components: { SimpleSelect } } )
export default class ProfilePreferences extends Vue {
    private readonly timezones = TIMEZONES;

    private timezone: string = "Europe/Paris";
    private timeFormat: "12" | "24" = "24";

    /* Baseline of the last saved values — the CTA stays disabled until something differs. */
    private savedTimezone: string = "Europe/Paris";
    private savedTimeFormat: "12" | "24" = "24";

    /* Le fuseau au composant du DS ( 26/09/2026 ) : huit zones, une liste simple. */
    private get timezoneOptions(): Option[] {
        return this.timezones.map(
            ( zone: TimeZoneOption ): Option => new CustomValue<string>( zone.Label, zone.Value )
        );
    }

    private get selectedTimezone(): Option | undefined {
        return this.timezoneOptions.find( ( option: Option ) => option.Id === this.timezone );
    }

    private selectTimezone( option: Option ): void {
        this.timezone = String( option.Id );
    }

    private get dirty(): boolean {
        return this.timezone !== this.savedTimezone
            || this.timeFormat !== this.savedTimeFormat;
    }

    private created(): void {
        const storedZone = localStorage.getItem( TIMEZONE_KEY );
        if( storedZone !== null && storedZone !== "" )
            this.timezone = storedZone;

        const storedFormat = localStorage.getItem( TIMEFORMAT_KEY );
        if( storedFormat === "12" || storedFormat === "24" )
            this.timeFormat = storedFormat;

        this.savedTimezone = this.timezone;
        this.savedTimeFormat = this.timeFormat;
    }

    private save(): void {
        if( !this.dirty )
            return;

        localStorage.setItem( TIMEZONE_KEY, this.timezone );
        localStorage.setItem( TIMEFORMAT_KEY, this.timeFormat );

        this.savedTimezone = this.timezone;
        this.savedTimeFormat = this.timeFormat;

        EventBus.Publish( "Notification", CustomNotification.Success(
            $t( "PROFILE_navPreferences" ), $t( "PROFILE_saved" )
        ));
    }

    private cancel(): void {
        this.timezone = this.savedTimezone;
        this.timeFormat = this.savedTimeFormat;
    }
}
